import { render, staticRenderFns } from "./haopinCount.vue?vue&type=template&id=50367bcc&scoped=true"
import script from "./haopinCount.vue?vue&type=script&lang=js"
export * from "./haopinCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50367bcc",
  null
  
)

export default component.exports